import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { devtools } from 'zustand/middleware';
import * as Sentry from '@sentry/react';

import { MemberResponse } from '@/entities/member';
import { setAuthToken, removeAuthToken, hasAuthToken } from '@/shared/lib/auth';

interface AuthState {
  member: MemberResponse | null;

  // 액션
  login: (token: string, member: MemberResponse) => void;
  logout: () => void;
  setMember: (member: MemberResponse) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        member: null,

        login: (token, member) => {
          setAuthToken(token);
          Sentry.setUser({ id: String(member.id) });
          set({ member });
        },
        logout: () => {
          removeAuthToken();
          Sentry.setUser(null);
          set({ member: null });
        },
        setMember: (member: MemberResponse) => set({ member }),
      }),
      {
        name: 'auth-storage',
        partialize: (state) => ({ member: state.member }),
        onRehydrateStorage: () => {
          return (state) => {
            // hydration 완료 후 토큰 없으면 persist된 member 정리
            if (state && !hasAuthToken() && state.member) {
              state.logout();
            }
          };
        },
      },
    ),
  ),
);
